import React, { useEffect, useState } from "react";
import axios from "axios";
// import { Search, XCircle } from "lucide-react";
import Badge from "./Badge";
import BlueButton from "./BlueButton";
import { BRAND } from "../css/brand";
import Card from "../Components/Card";
import SimpleTable from "../Components/SimpleTable";
import ApplyPolicyModal from "./ApplyPolicyModal";
import Swal from "sweetalert2";
import Header from "./Header";
import { Search, XCircle, Download, CheckCircle, CheckCircle2 } from "lucide-react";

export default function CustomerCards({ retailer_id: propRetailerId }) {
  const [customers, setCustomers] = useState([]);
  const [summary, setSummary] = useState({});
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);

  // ✅ Fetch logged-in user data from session
  const authUser = JSON.parse(sessionStorage.getItem("authUserData1"));
  const role = authUser.data[0]?.role;
  const sessionCompanyId = authUser.data[0]?.id;
  const sessionId = authUser.data[0]?.id;
  const sessionDistId = authUser.data[0]?.dist_id;
  console.log("role: ",role)

  // ✅ Determine API params dynamically
  let apiParamKey, apiParamValue, loginIdValue;

  if (propRetailerId) {
  // 🧾 Retailer view opened from Company
  apiParamKey = "retailer_id";
  apiParamValue = propRetailerId;
  loginIdValue = propRetailerId;
} else if (role === 2) {
  // 🏢 Company user
  apiParamKey = "company_id";
  apiParamValue = sessionId;
  loginIdValue = sessionId;
} else if (role === 3) {
  // 🏭 CNF user
  apiParamKey = "cnf_id";
  apiParamValue = sessionId;
  loginIdValue = sessionId;
} else if (role === 4) {
  // 🏪 Super Stockist user
  apiParamKey = "ss_id";
  apiParamValue = sessionId;
  loginIdValue = sessionId;
} else if (role === 5) {
  // 🧾 Distributor user
  apiParamKey = "dist_id";
  apiParamValue = sessionId;
  loginIdValue = sessionId;
} else if (role === 6) {
  // 🧍‍♂️ FOS user
  apiParamKey = "dist_id";
  apiParamValue = sessionDistId; // ✅ From session, not own id
  loginIdValue = sessionId; // still pass their own id as login_id
} else if (role === 7) {
  // 🧍 Retailer logged in
  apiParamKey = "retailer_id";
  apiParamValue = sessionId;
  loginIdValue = sessionId;
}

  

  useEffect(() => {
    fetchCustomers();
  }, [page]);

  const rowsPerPage = 20;
  const totalPages = Math.ceil(total / rowsPerPage);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      setError(null);

      const url = `https://spillas.com/api/v1/get-customers?${apiParamKey}=${apiParamValue}&login_id=${loginIdValue}&page=${page}`;
      const res = await axios.get(url);

      const data = res.data;
      setCustomers(data.data || []);
      setSummary(data.summary || {});
      setTotal(data.total || 0);
    } catch (err) {
      console.error("Error fetching customers:", err);
      setError("Failed to fetch customers");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      setError(null);

      const url = `https://spillas.com/api/v1/search-customers?value=${encodeURIComponent(
        search
      )}&${apiParamKey}=${apiParamValue}&login_id=${loginIdValue}&page=1`;

      const res = await axios.get(url);
      setCustomers(res.data.data || []);
      setSummary(res.data.summary || {});
      setTotal(res.data.total || 0);
    } catch (err) {
      console.error(err);
      setError("Search failed");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setSearch("");
    fetchCustomers();
  };

  // ✅ CSV Download Function
  // ✅ CSV Download Function - Fetches All Pages
    const handleDownload = async () => {
      try {
        setLoading(true);
        setError(null);

        let allCustomers = [];
        let currentPage = 1;
        const perPage = 100; // API default or safe limit
        let totalPages = 1;

        // 🔁 Loop to fetch all pages until done
        do {
          const url = `https://spillas.com/api/v1/get-customers?${apiParamKey}=${apiParamValue}&login_id=${loginIdValue}&page=${currentPage}`;
          const res = await axios.get(url);
          const data = res.data;

          const customersPage = data.data || [];
          allCustomers = [...allCustomers, ...customersPage];

          const totalRecords = data.total || 0;
          totalPages = Math.ceil(totalRecords / perPage);
          currentPage++;
        } while (currentPage <= totalPages);

        if (allCustomers.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "No Data",
            text: "There are no customers to download.",
            confirmButtonColor: "#3B82F6",
          });
          return;
        }

        // ✅ Prepare CSV Headers
        const headers = [
          "Sr No.",
          "Name",
          "Mobile",
          "Model",
          "Enterprise ID",
          "Device ID",
          "Customer Type",
          "IMEI 1",
          "IMEI 2",
          "Enrollment Date",
          "Policy",
          "Last Sync",
          "Mapped",
        ];

        const csvRows = [headers.join(",")];

        // ✅ Format Each Row
        allCustomers.forEach((cust, i) => {
          const enterprise =
            cust.enterprise ||
            (cust.ama_device_id?.includes("enterprises/")
              ? cust.ama_device_id.split("/")[1]
              : "-");
          const device =
            cust.ama_device_id?.includes("enterprises/")
              ? cust.ama_device_id.split("/")[3]
              : cust.ama_device_id || "-";

          const row = [
            i + 1,
            cust.name || "-",
            cust.mobile || "-",
            cust.model || "-",
            enterprise,
            device,
            cust.customer_type === 1
              ? "Recommended"
              : cust.customer_type === 3
              ? "Chalte Chalte"
              : "Other",
            cust.imei1 || "-",
            cust.imei2 || "-",
            cust.enrollment_time
              ? new Date(cust.enrollment_time).toLocaleDateString()
              : "-",
            cust.policy ? cust.policy.split("/").pop() : "-",
            cust.last_sync ? new Date(cust.last_sync).toLocaleString() : "-",
            cust.is_mapped === 1 ? "Mapped" : "Unmapped",
          ];

          csvRows.push(row.join(","));
        });

        // ✅ Create and Trigger CSV Download
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `all_customers_${new Date()
          .toISOString()
          .slice(0, 10)}.csv`;
        link.click();
        URL.revokeObjectURL(url);

        Swal.fire({
          icon: "success",
          title: "Download Complete",
          text: `Exported ${allCustomers.length} customers successfully.`,
          confirmButtonColor: "#3B82F6",
        });
      } catch (err) {
        console.error("Download error:", err);
        Swal.fire({
          icon: "error",
          title: "Download Failed",
          text: "Unable to export CSV file.",
          confirmButtonColor: "#3B82F6",
        });
      } finally {
        setLoading(false);
      }
    };

  return (
    <div className="p-2 bg-gray-50 min-h-screen">
      {/* 🔍 Search & Summary */}
      <Header brand={BRAND} title="Customers" />
      <div className="flex flex-wrap gap-3 items-center mb-6">
  {/* 🔍 Search & Reset */}
  <div className="flex gap-2 items-center w-full sm:w-auto">
    <input
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      placeholder="Search by Name, Mobile, IMEI"
      className="w-full sm:w-72 border border-gray-300 rounded-lg px-3 py-2 text-sm"
    />

    {/* Search Button */}
    <BlueButton
      brand={BRAND}
      onClick={handleSearch}
      className="inline-flex items-center gap-1"
    >
      <Search className="h-4 w-4" />
      <span className="hidden sm:inline ml-1">Search</span>
    </BlueButton>

    {/* Reset Button */}
    <BlueButton
      brand={BRAND}
      onClick={handleReset}
      className="inline-flex items-center gap-1"
    >
      <XCircle className="h-4 w-4" />
      <span className="hidden sm:inline ml-1">Reset</span>
    </BlueButton>
    <BlueButton
      brand={BRAND}
      onClick={handleDownload}
      className="inline-flex items-center gap-1"
    >
      <Download className="h-4 w-4" />
      <span className="hidden sm:inline ml-1">Download</span>
    </BlueButton>
  </div>

  {/* 🧾 Summary Badges */}
    <div className="ml-auto flex flex-wrap items-center gap-2 sm:gap-3 text-xs sm:text-sm">
    {/* ✅ Total */}
    <span className="flex items-center gap-1 px-2 sm:px-3 py-1 rounded-full bg-green-100 text-green-700 font-medium border border-green-300">
      {/* Show 'T' on small screens, 'Total:' on sm+ */}
      <span className="inline sm:hidden">T:</span>
      <span className="hidden sm:inline">Total:</span> {total}
    </span>

    {/* ✅ Mapped */}
    <span className="flex items-center gap-1 px-2 sm:px-3 py-1 rounded-full bg-blue-100 text-blue-700 font-medium border border-blue-300">
      <span className="inline sm:hidden">M:</span>
      <span className="hidden sm:inline">Mapped:</span> {summary?.mapped || 0}
    </span>

    {/* ✅ Unmapped */}
    <span className="flex items-center gap-1 px-2 sm:px-3 py-1 rounded-full bg-red-100 text-red-700 font-medium border border-red-300">
      <span className="inline sm:hidden">UM:</span>
      <span className="hidden sm:inline">Unmapped:</span> {summary?.unmapped || 0}
    </span>
  </div>

</div>


      {/* 🧾 Table View */}
      <Card brand={BRAND} >
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : customers.length === 0 ? (
          <p>No customers found</p>
        ) : (
          <>
            <SimpleTable
              headers={[
                "Sr No.",
                "Name",
                "Mobile",
                "Model",
                "Device Details",
                "Type",
                "REG.IN",
                "IMEI Details",
                "Enrolled",
                "Policy",
                "Last Sync",
                "Mapped",
                "Action",
              ]}
              rows={customers.map((cust, i) => [
                (page - 1) * rowsPerPage + i + 1,
                cust.name || "-",
                cust.mobile || "-",
                cust.model || "-",
                <div className="flex flex-col text-xs break-all">
                  <span>
                    {cust.enterprise
                      ? cust.enterprise
                      : cust.ama_device_id && cust.ama_device_id.includes("enterprises/")
                      ? cust.ama_device_id.split("/")[1] || "-"
                      : "-"}
                  </span>

                  <span>
                    {cust.ama_device_id
                      ? cust.ama_device_id.includes("enterprises/")
                        ? cust.ama_device_id.split("/")[3] || "-"
                        : cust.ama_device_id
                      : "-"}
                  </span>
                </div>,
                cust.customer_type === 1
                  ? Badge("Recommended", "green")
                  : cust.customer_type === 3
                  ? Badge("Chalte Chalte", "indigo")
                  : Badge("Other", "gray"),
                
                cust.fcm ? (
                    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-emerald-100 text-emerald-700 text-xs font-medium">
                      <CheckCircle size={20} />
                      CC
                    </span>
                  ) : (
                    "-"
                  ),
                <div className="">
                  <span>{cust.imei1 || "-"}</span><br/>
                  <span>{cust.imei2 || "-"}</span>
                </div>,

                
                
                
                cust.enrollment_time
                  ? new Date(cust.enrollment_time).toLocaleDateString()
                  : "-",
                cust?.policy ? cust.policy.split("/").pop() : "-",
                cust.last_sync
                  ? new Date(cust.last_sync).toLocaleString()
                  : "-",
                //   <BlueButton brand={BRAND}
                //   onClick={() => {
                //     if (cust.ama_device_id) {
                //       const parts = cust.ama_device_id.split("/");
                //       const enterprise_id = parts[1] || "";
                //       const device_id = parts[3] || "";
                //       setSelectedDevice({ device_id, enterprise_id });
                //     } else {
                //       Swal.fire({
                //         icon: "warning",
                //         title: "Device Not Found",
                //         text: "No device ID and enterprise ID available for this customer.",
                //         confirmButtonColor: "#3B82F6", // optional - matches BlueButton
                //       });
                //     }
                //   }}
                //   className="text-blue-600 hover:underline"
                // >
                //   Apply Policy
                // </BlueButton>,
                cust.is_mapped === 1
                  ? Badge("Mapped", "blue")
                  : Badge("Unmapped", "red"),
                  
                // <BlueButton
                //   brand={BRAND}
                //   onClick={() => {
                //     const enterprise_id = cust.enterprise
                //       ? cust.enterprise
                //       : cust.ama_device_id && cust.ama_device_id.includes("enterprises/")
                //       ? cust.ama_device_id.split("/")[1] || "-"
                //       : "-";
                //     const device_id = cust.ama_device_id
                //       ? cust.ama_device_id.includes("enterprises/")
                //         ? cust.ama_device_id.split("/")[3] || "-"
                //         : cust.ama_device_id
                //       : "-";
                //     const type = cust.customer_type;

                //     // If type = 3 → show "Chalte Chalte" message
                //     if (type === 3) {
                //       Swal.fire({
                //         icon: "warning",
                //         title: "Chalte Chalte Customer",
                //         text: "Selected customer is 'Chalte Chalte'. You cannot apply a policy.",
                //         confirmButtonColor: "#3B82F6",
                //       });
                //       return;
                //     }

                //     // If type = 1 (Smart) → check for missing info
                //     if (type === 1 && (!enterprise_id || !device_id)) {
                //       Swal.fire({
                //         icon: "warning",
                //         title: "Missing Information",
                //         text: "Device ID or Enterprise ID is missing. Please verify the customer's details.",
                //         confirmButtonColor: "#3B82F6",
                //       });
                //       return;
                //     }

                //     // Otherwise → proceed
                //     setSelectedDevice({ device_id, enterprise_id });
                //   }}
                //   className="text-blue-600 hover:underline"
                // >
                //   Apply Policy
                // </BlueButton>,
                <BlueButton
                  brand={BRAND}
                  onClick={() => {
                    // ✅ Extract enterprise_id and device_id properly
                    const enterprise_id =
                      cust.enterprise ||
                      (cust.ama_device_id?.includes("enterprises/")
                        ? cust.ama_device_id.split("/")[1]
                        : null);

                    const device_id =
                      cust.ama_device_id?.includes("enterprises/")
                        ? cust.ama_device_id.split("/")[3]
                        : cust.ama_device_id || null;

                    const type = cust.customer_type;
                    

                    // 🟠 Case 1: Chalte Chalte Customer
                    if (type === 3) {
                      Swal.fire({
                        icon: "warning",
                        title: "Chalte Chalte Customer",
                        text: "Selected customer is 'Chalte Chalte'. You cannot apply a policy.",
                        confirmButtonColor: "#3B82F6",
                      });
                      return;
                    }

                    // 🟡 Case 2: Missing Enterprise ID or Device ID
                    // if (!enterprise_id || !device_id) {
                    //   Swal.fire({
                    //     icon: "warning",
                    //     title: "Missing Information",
                    //     text: "Device ID or Enterprise ID is not available. Please verify the customer's details.",
                    //     confirmButtonColor: "#3B82F6",
                    //   });
                    //   return;
                    // }

                    // 🟢 Case 3: All good → proceed
                    setSelectedDevice(cust);
                  }}
                  className="text-blue-600 hover:underline"
                >
                  Apply Policy
                </BlueButton>,


              ])}
            />

            {/* Pagination */}
            <div className="flex gap-2 justify-end mt-3 items-center flex-wrap">
              {/* Prev Button */}
              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
                className="px-2 py-1 border rounded disabled:opacity-50"
              >
                Prev
              </button>

              {/* Page Numbers */}
              {(() => {
                const pages = [];
                const totalToShow = 5; // number of pages visible in pagination
                let start = Math.max(1, page - Math.floor(totalToShow / 2));
                let end = Math.min(totalPages, start + totalToShow - 1);

                if (end - start < totalToShow - 1) {
                  start = Math.max(1, end - totalToShow + 1);
                }

                for (let i = start; i <= end; i++) {
                  pages.push(i);
                }

                return (
                  <>
                    {pages[0] > 1 && (
                      <>
                        <button
                          className="px-2 py-1 border rounded"
                          onClick={() => setPage(1)}
                        >
                          1
                        </button>
                        {pages[0] > 2 && <span className="px-2">...</span>}
                      </>
                    )}

                    {pages.map((p) => (
                      <button
                        key={p}
                        className={`px-2 py-1 border rounded ${
                          page === p ? "bg-blue-500 text-white" : ""
                        }`}
                        onClick={() => setPage(p)}
                      >
                        {p}
                      </button>
                    ))}

                    {pages[pages.length - 1] < totalPages && (
                      <>
                        {pages[pages.length - 1] < totalPages - 1 && (
                          <span className="px-2">...</span>
                        )}
                        <button
                          className="px-2 py-1 border rounded"
                          onClick={() => setPage(totalPages)}
                        >
                          {totalPages}
                        </button>
                      </>
                    )}
                  </>
                );
              })()}

              {/* Next Button */}
              <button
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
                className="px-2 py-1 border rounded disabled:opacity-50"
              >
                Next
              </button>
            </div>


            {selectedDevice && (
              <ApplyPolicyModal
                device={selectedDevice}
                onClose={() => setSelectedDevice(null)}
              />
            )}
          </>
        )}
      </Card>
    </div>
  );
}



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { motion } from "framer-motion";
// import { Search, MapPin, Shield, Smartphone } from "lucide-react";
// import  Badge from "./Badge";
// import BlueButton from "./BlueButton";
// // import { Input } from "@/components/ui/input";
// import { BRAND } from "../css/brand";

// export default function CustomerCards({company_id, login_id} ) {
// const [customers, setCustomers] = useState([]);
// const [summary, setSummary] = useState({});
// const [page, setPage] = useState(1);
// const [search, setSearch] = useState("");
// const [loading, setLoading] = useState(false);
// const [total, setTotal] = useState(0);

// //   const company_id = null;
// //   const login_id = null;

// useEffect(() => {
//     fetchCustomers();
// }, [page]);

// const fetchCustomers = async () => {
//     try {
//     setLoading(true);
//     const url = `https://spillas.com/api/v1/get-customers?company_id=${company_id}&login_id=${login_id}&page=${page}`;
//     const res = await axios.get(url);
//     const data = res.data;
//     setCustomers(data.data || []);
//     setSummary(data.summary || {});
//     setTotal(data.total || 0);
//     } catch (err) {
//     console.error("Error fetching customers:", err);
//     } finally {
//     setLoading(false);
//     }
// };

// const handleSearch = async () => {
//     try {
//     setLoading(true);
//     const url = `https://spillas.com/api/v1/get-customers?company_id=${company_id}&login_id=${login_id}&search=${search}`;
//     const res = await axios.get(url);
//     setCustomers(res.data.data || []);
//     setSummary(res.data.summary || {});
//     } catch (err) {
//     console.error(err);
//     } finally {
//     setLoading(false);
//     }
// };

// return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//     {/* 🔍 Search & Filters */}
//     <div className="flex flex-wrap gap-3 items-center mb-6">
//         <input
//         value={search}
//         onChange={(e) => setSearch(e.target.value)}
//         placeholder="Search by Name, Mobile, IMEI"
//         className="w-72"
//         />
//         <BlueButton brand={BRAND} onClick={handleSearch}>
//         <Search className="h-4 w-4 mr-2" /> Search
//         </BlueButton>

//        <div className="ml-auto flex items-center gap-3">
//         <span className="px-3 py-1 rounded-full bg-green-100 text-green-700 text-sm font-medium border border-green-300">
//             Total Customers: {total}
//         </span>
//         <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-sm font-medium border border-blue-300">
//             Mapped: {summary?.mapped || 0}
//         </span>
//         <span className="px-3 py-1 rounded-full bg-red-100 text-red-700 text-sm font-medium border border-red-300">
//             Unmapped: {summary?.unmapped || 0}
//         </span>
//         </div>

//     </div>

//     {/* 🧾 Cards Grid */}
//     {loading ? (
//         <p className="text-center text-gray-500 mt-10">Loading customers...</p>
//     ) : (
//         <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
//         {customers.map((cust, idx) => (
//             <motion.div
//             key={cust.id}
//             initial={{ opacity: 0, y: 10 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: idx * 0.05 }}
//             className="relative rounded-2xl border bg-white shadow-sm hover:shadow-md transition-all p-5"
//             >
//             {/* Mapped / Unmapped Label */}
//             <div
//                 className={`absolute right-0 top-0 rounded-tr-2xl rounded-bl-2xl px-3 py-1 text-xs font-semibold text-white ${
//                 cust.is_mapped === 1
//                     ? "bg-green-500"
//                     : cust.is_mapped === 0
//                     ? "bg-red-500"
//                     : "bg-red-400"
//                 }`}
//             >
//                 {cust.is_mapped ? "Mapped" : "Unmapped"}
//             </div>

//             {/* Header */}
//             <div className="flex items-center gap-3 mb-4">
//                 <div className="grid h-12 w-12 place-items-center rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 text-white shadow">
//                 <Shield className="h-6 w-6" />
//                 </div>
//                 <div>
//                 <h3 className="font-semibold text-gray-800 capitalize">
//                     {cust.name || "N/A"}
//                 </h3>
//                 <p className="text-xs text-gray-500">
//                     {cust.mobile || "N/A"}
//                 </p>
//                 </div>
//             </div>

//             {/* Device Info */}
//             <div className="space-y-1 text-sm">
//                 <p>
//                 <span className="font-medium text-gray-600">Model:</span>{" "}
//                 {cust.model || "-"}
//                 </p>
//                 <p>
//                 <span className="font-medium text-gray-600">Enrolled:</span>{" "}
//                 {cust.enrollment_time
//                     ? new Date(cust.enrollment_time).toLocaleDateString()
//                     : "-"}
//                 </p>
//                 <p>
//                 <span className="font-medium text-gray-600">IMEI 1:</span>{" "}
//                 {cust.imei1 || "-"}
//                 </p>
//                 <p>
//                 <span className="font-medium text-gray-600">IMEI 2:</span>{" "}
//                 {cust.imei2 || "-"}
//                 </p>
//                 <p>
//                 <span className="font-medium text-gray-600">Enterprise:</span>{" "}
//                 {cust.enterprise || "-"}
//                 </p>
//                 <p>
//                 <span className="font-medium text-gray-600">Current:</span>{" "}
//                 {cust.policy || "-"}
//                 </p>
//                 <p>
//                 <span className="font-medium text-gray-600">Last Sync:</span>{" "}
//                 {cust.last_sync
//                     ? new Date(cust.last_sync).toLocaleString()
//                     : "-"}
//                 </p>
//             </div>

//             {/* Actions */}
//             <div className="mt-4">
//                 <BlueButton brand={BRAND} className="w-full bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl">
//                 Apply Policy
//                 </BlueButton>
//             </div>
//             </motion.div>
//         ))}
//         </div>
//     )}

//     {/* Pagination */}
//     <div className="flex justify-center items-center gap-4 mt-8">
//         <BlueButton brand={BRAND}
//         variant="outline"
//         disabled={page === 1}
//         onClick={() => setPage((p) => p - 1)}
//         >
//         Prev
//         </BlueButton>
//         <span className="text-sm text-gray-600">Page {page}</span>
//         <BlueButton brand={BRAND}
//         variant="outline"
//         onClick={() => setPage((p) => p + 1)}
//         >
//         Next
//         </BlueButton>
//     </div>
//     </div>
// );
// }
